import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsStageCompositionPoint } from "@/http/api-types";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";
import { secondsToDays } from "./formatters";

export function ApprovedToDoneTrendChart({ data }: { data: JiraMetricsStageCompositionPoint[] }) {
  const chartData = data.map(point => ({
    period: point.period,
    approved_to_done_days: secondsToDays(point.avg_approved_to_done_seconds),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Changes Approved to Moved to Done Trend</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer
          className="h-72 w-full"
          config={{ approved_to_done_days: { label: "Avg Workdays", color: "#06b6d4" } }}
        >
          <LineChart data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="period" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <ChartLegend content={<ChartLegendContent />} />
            <Line
              type="monotone"
              dataKey="approved_to_done_days"
              stroke="var(--color-approved_to_done_days)"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
